import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountModelFormComponent } from './account-model-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BsbFormControlModule } from '@fleet/shared';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  declarations: [AccountModelFormComponent],
  imports: [
    CommonModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    BsbFormControlModule,
  ],
  exports: [AccountModelFormComponent],
})
export class AccountModelFormModule {}
